(function () {
    const scheduledDeliveryPostCodeChecker = document.querySelectorAll('.scheduled-delivery-postcode-checker');

    const formatResponseData = (data) => {
        let formattedData = '<div class="d-flex flex-column gap-2">';

        data.forEach((element) => {
            formattedData += `<div class="d-flex align-items-center gap-2"><span class="icon icon-check-20 p-1 bg-green-500 rounded-circle text-white" style="font-size: 12px"></span><div>${element}</div></div>`;
        });

        return (formattedData += '</div>');
    };

    const getScheduledDates = async (url, data) => {
        const response = await fetch(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'X-Requested-With': 'XMLHttpRequest',
            },
            body: JSON.stringify(data),
        });

        return response.json();
    };

    scheduledDeliveryPostCodeChecker.forEach((element) => {
        const searchButton = element.querySelector('.search-button');
        const formElement = element.querySelector('.scheduled-delivery-form');
        const inputField = formElement.querySelector('input');
        const submitButton = formElement.querySelector('button');
        const requiredFieldMessageElement = element.querySelector('.scheduled-delivery-required-field');
        const successResponseElement = element.querySelector('.scheduled-delivery-response-success');
        const successResponseData = element.querySelector('.scheduled-delivery-response-data');
        const failResponseElement = element.querySelector('.scheduled-delivery-response-fail');

        searchButton.addEventListener('click', () => {
            searchButton.classList.add('d-none');
            formElement.classList.remove('d-none');
        });

        submitButton.addEventListener('click', (e) => {
            const postcode = inputField.value;

            requiredFieldMessageElement.classList.add('d-none');

            if (!postcode) {
                e.stopImmediatePropagation();
                requiredFieldMessageElement.classList.remove('d-none');
                return;
            }

            getScheduledDates(element.dataset.url, { postcode: postcode }).then((data) => {
                if (data.status === 'fail') {
                    successResponseData.innerHTML = '';
                    successResponseElement.classList.add('d-none');
                    failResponseElement.classList.remove('d-none');
                } else {
                    failResponseElement.classList.add('d-none');
                    successResponseData.innerHTML = formatResponseData(data.data);
                    successResponseElement.classList.remove('d-none');
                }

                submitButton.classList.remove('loading');
            });
        });

        document.addEventListener('keypress', (event) => {
            if (document.activeElement === inputField && event.key === 'Enter') {
                event.preventDefault();
                submitButton.dispatchEvent(new Event('click'));
            }
        });
    });
})();
